module.exports = __webpack_public_path__ + "img/pageCover.ecfd4b58.jpeg";